<div class="tw-flex tw-flex-1 tw-flex-col tw-items-start tw-gap-4 tw-rounded-2.5 tw-bg-gray-100 tw-pb-8 tw-pl-5 tw-pr-2"
  role="button"
  (click)="handleSelect()">
  <img class="-tw-mt-4.5 tw-h-22 tw-w-22"
    [src]="iconUrl()"
    alt="" />
  <div class="tw-flex tw-flex-col tw-gap-6">
    <div class="tw-font-lexend tw-text-600 tw-leading-1.2 tw-text-gray-800">
      <ng-content></ng-content>
    </div>
    <button csButton
      size="small"
      type="button"
      tabindex="-1"
      class="tw-pointer-events-none tw-mx-0 tw-w-fit tw-min-w-unset tw-self-start tw-px-4 tw-transition-none"><span i18n="@@clickHere">Click Here</span>
    </button>
  </div>
</div>
